module.exports={
  "range": [
    {
      "label": "Shutter - Antigua Express",
      "value": "antigua-express",
      "minWidth": 250,
      "minHeight": 500,
      "maxWidth": 2400,
      "maxHeight": 2000,
      "maxPanels": 4,
      "minWidthPerPanel": 250,
      "maxWidthPerPanel": 600,
      "tiersplitRequiredAtHeight": 1879,
      "colors": [
        "colour-001",
        "colour-003"
      ],
      "hinges": [
        "white"
      ],
      "knobs": [
      ],
      "panelConfigurationOverrides": {
        "3": [
          {
            "value": "LLR",
            "label": "LLR"
          },
          {
            "value": "LRR",
            "label": "LRR"
          }
        ],
        "4": [
          {
            "value": "LLRR",
            "label": "LLRR"
          }
        ]
      }
    },
    {
      "label": "Shutter - Antigua",
      "value": "antigua",
      "minWidth": 250,
      "minHeight": 500,
      "maxWidth": 2400,
      "maxHeight": 2000,
      "maxPanels": 4,
      "minWidthPerPanel": 250,
      "maxWidthPerPanel": 600,
      "tiersplitRequiredAtHeight": 1981,
      "colors": [
        "colour-003",
        "colour-001",
        "colour-006",
        "colour-032",
        "colour-002",
        "colour-decorators-white"
      ],
      "hinges": [
        "bright-brass",
        "antique-brass",
        "brushed-nickel",
        "nickel",
        "pearl",
        "white",
        "bisque"
      ],
      "knobs": [
      ],
      "panelConfigurationOverrides": {
        "3": [
          {
            "value": "LLR",
            "label": "LLR"
          },
          {
            "value": "LRR",
            "label": "LRR"
          }
        ],
        "4": [
          {
            "value": "LLRR",
            "label": "LLRR"
          }
        ]
      }
    },
    {
      "label": "Shutter - Bermuda",
      "value": "bermuda",
      "minWidth": 250,
      "minHeight": 500,
      "maxWidth": 2440,
      "maxHeight": 2000,
      "maxPanels": 4,
      "minWidthPerPanel": 250,
      "maxWidthPerPanel": 610,
      "tiersplitRequiredAtHeight": 1981,
      "colors": [
        "colour-004",
        "colour-002",
        "colour-003",
        "colour-001",
        "colour-006",
        "colour-009",
        "colour-049",
        "colour-053",
        "colour-032",
        "colour-aura-white",
        "colour-decorators-white"
      ],
      "hinges": [
        "bright-brass",
        "antique-brass",
        "brushed-nickel",
        "nickel",
        "pearl",
        "white",
        "bisque"
      ],
      "knobs": [
      ],
      "panelConfigurationOverrides": {
        "3": [
          {
            "value": "LLR",
            "label": "LLR"
          },
          {
            "value": "LRR",
            "label": "LRR"
          }
        ],
        "4": [
          {
            "value": "LLRR",
            "label": "LLRR"
          }
        ]
      }
    },
    {
      "label": "Shutter - Cuba",
      "value": "cuba",
      "minWidth": 250,
      "minHeight": 500,
      "maxWidth": 4400,
      "maxHeight": 3000,
      "maxPanels": 8,
      "minWidthPerPanel": 250,
      "maxWidthPerPanel": 550,
      "tiersplitRequiredAtHeight": 1981,
      "colors": [
        "colour-004",
        "colour-002",
        "colour-003",
        "colour-001",
        "colour-006",
        "colour-009",
        "colour-049",
        "colour-053",
        "colour-032",
        "colour-aura-white",
        "colour-decorators-white"
      ],
      "hinges": [
        "bright-brass",
        "antique-brass",
        "brushed-nickel",
        "nickel",
        "pearl",
        "white",
        "bisque"
      ],
      "knobs": [
      ]
    },
    {
      "label": "Shutter - Fiji",
      "value": "fiji",
      "minWidth": 250,
      "minHeight": 500,
      "maxWidth": 4400,
      "maxHeight": 3000,
      "maxPanels": 8,
      "minWidthPerPanel": 250,
      "maxWidthPerPanel": 550,
      "tiersplitRequiredAtHeight": 1981,
      "colors": [
        "colour-004",
        "colour-002",
        "colour-003",
        "colour-001",
        "colour-006",
        "colour-009",
        "colour-049",
        "colour-053",
        "colour-032",
        "colour-aura-white",
        "colour-decorators-white",
        "colour-polaris",
        "colour-dover-white",
        "colour-summer-haze",
        "colour-winchester-white",
        "colour-chalk-white",
        "colour-007",
        "colour-cotswold-white",
        "colour-steam",
        "colour-012",
        "colour-019",
        "colour-harris",
        "colour-calico",
        "colour-magma",
        "colour-coltrane",
        "colour-office",
        "colour-scraft-080",
        "colour-platter",
        "colour-anthracite",
        "colour-classic-black",
        "stain-110",
        "stain-rustic-gray",
        "stain-862",
        "stain-204",
        "stain-227",
        "stain-229",
        "stain-211",
        "stain-212",
        "stain-215",
        "stain-220",
        "stain-219",
        "stain-mahogany",
        "stain-230",
        "stain-237",
        "stain-109",
        "stain-221",
        "stain-matt-black",
        "stain-osmo-white-matt",
        "stain-osmo-silk-grey",
        "stain-osmo-oak",
        "stain-osmo-teak",
        "stain-osmo-oak-antique",
        "stain-osmo-granite-grey"
      ],
      "hinges": [
        "bright-brass",
        "antique-brass",
        "brushed-nickel",
        "nickel",
        "pearl",
        "white",
        "bisque",
        "black"
      ],
      "knobs": [
      ]
    },
    {
      "label": "Shutter - Sumatra",
      "value": "sumatra",
      "minWidth": 250,
      "minHeight": 500,
      "maxWidth": 4400,
      "maxHeight": 3000,
      "maxPanels": 8,
      "minWidthPerPanel": 250,
      "maxWidthPerPanel": 550,
      "tiersplitRequiredAtHeight": 1981,
      "colors": [
        "colour-001",
        "colour-002",
        "colour-003",
        "colour-004",
        "colour-006",
        "colour-007",
        "colour-008",
        "colour-009",
        "colour-011",
        "colour-012",
        "colour-013",
        "colour-014",
        "colour-016",
        "colour-019",
        "colour-032",
        "colour-048",
        "colour-049",
        "colour-051",
        "colour-053",
        "colour-064",
        "colour-065",
        "colour-066",
        "colour-067",
        "colour-068",
        "colour-069",
        "colour-070",
        "colour-071",
        "colour-072",
        "stain-108",
        "stain-109",
        "stain-110",
        "stain-114",
        "stain-202",
        "stain-204",
        "stain-205",
        "stain-211",
        "stain-212",
        "stain-214",
        "stain-215",
        "stain-219",
        "stain-220",
        "stain-221",
        "stain-227",
        "stain-229",
        "stain-230",
        "stain-232",
        "stain-237",
        "stain-862"
      ],
      "hinges": [
        "bright-brass",
        "antique-brass",
        "brushed-nickel",
        "nickel",
        "pearl",
        "white",
        "bisque",
        "black"
      ],
      "knobs": [
      ]
    },
    {
      "label": "Shutter - Java",
      "value": "java",
      "minWidth": 250,
      "minHeight": 500,
      "maxWidth": 2200,
      "maxHeight": 3000,
      "maxPanels": 4,
      "minWidthPerPanel": 250,
      "maxWidthPerPanel": 550,
      "tiersplitRequiredAtHeight": 1879,
      "colors": [
        "colour-004",
        "colour-002",
        "colour-003",
        "colour-001",
        "colour-006",
        "colour-009",
        "colour-049",
        "colour-053",
        "colour-032",
        "colour-aura-white",
        "colour-decorators-white"
      ],
      "hinges": [
        "stainless-steel"
      ],
      "knobs": [
      ],
      "panelConfigurationOverrides": {
        "3": [
          {
            "value": "LLR",
            "label": "LLR"
          },
          {
            "value": "LRR",
            "label": "LRR"
          }
        ],
        "4": [
          {
            "value": "LLRR",
            "label": "LLRR"
          }
        ]
      }
    },
    {
      "label": "Shutter - Solid Shaker",
      "value": "solid-shaker",
      "minWidth": 500,
      "minHeight": 500,
      "maxWidth": 2200,
      "maxHeight": 1900,
      "maxPanels": 4,
      "minWidthPerPanel": 250,
      "maxWidthPerPanel": 550,
      "colors": [
        "colour-004",
        "colour-002",
        "colour-003",
        "colour-001",
        "colour-006",
        "colour-009",
        "colour-049",
        "colour-053",
        "colour-032",
        "colour-aura-white",
        "colour-decorators-white",
        "colour-polaris",
        "colour-dover-white",
        "colour-summer-haze",
        "colour-winchester-white",
        "colour-chalk-white",
        "colour-007",
        "colour-cotswold-white",
        "colour-steam",
        "colour-012",
        "colour-019",
        "colour-harris",
        "colour-calico",
        "colour-magma",
        "colour-coltrane",
        "colour-office",
        "colour-scraft-080",
        "colour-platter",
        "colour-anthracite",
        "colour-classic-black",
        "stain-110",
        "stain-rustic-gray",
        "stain-862",
        "stain-204",
        "stain-227",
        "stain-229",
        "stain-211",
        "stain-212",
        "stain-215",
        "stain-220",
        "stain-219",
        "stain-mahogany",
        "stain-230",
        "stain-237",
        "stain-109",
        "stain-221",
        "stain-matt-black",
        "stain-osmo-white-matt",
        "stain-osmo-silk-grey",
        "stain-osmo-oak",
        "stain-osmo-teak",
        "stain-osmo-oak-antique",
        "stain-osmo-granite-grey"
      ],
      "hinges": [
        "bright-brass",
        "antique-brass",
        "brushed-nickel",
        "nickel",
        "pearl",
        "white",
        "bisque"
      ],
      "knobs": [
        "brushed-nickel"
      ]
    },
    {
      "label": "Shutter - Solid Raised",
      "value": "solid-raised",
      "minWidth": 250,
      "minHeight": 500,
      "maxWidth": 2200,
      "maxHeight": 1900,
      "maxPanels": 4,
      "minWidthPerPanel": 250,
      "maxWidthPerPanel": 550,
      "colors": [
        "colour-004",
        "colour-002",
        "colour-003",
        "colour-001",
        "colour-006",
        "colour-009",
        "colour-049",
        "colour-053",
        "colour-032",
        "colour-aura-white",
        "colour-decorators-white",
        "colour-polaris",
        "colour-dover-white",
        "colour-summer-haze",
        "colour-winchester-white",
        "colour-chalk-white",
        "colour-007",
        "colour-cotswold-white",
        "colour-steam",
        "colour-012",
        "colour-019",
        "colour-harris",
        "colour-calico",
        "colour-magma",
        "colour-coltrane",
        "colour-office",
        "colour-scraft-080",
        "colour-platter",
        "colour-anthracite",
        "colour-classic-black",
        "stain-110",
        "stain-rustic-gray",
        "stain-862",
        "stain-204",
        "stain-227",
        "stain-229",
        "stain-211",
        "stain-212",
        "stain-215",
        "stain-220",
        "stain-219",
        "stain-mahogany",
        "stain-230",
        "stain-237",
        "stain-109",
        "stain-221",
        "stain-matt-black",
        "stain-osmo-white-matt",
        "stain-osmo-silk-grey",
        "stain-osmo-oak",
        "stain-osmo-teak",
        "stain-osmo-oak-antique",
        "stain-osmo-granite-grey"
      ],
      "hinges": [
        "bright-brass",
        "antique-brass",
        "brushed-nickel",
        "nickel",
        "pearl",
        "white",
        "bisque"
      ],
      "knobs": [
        "brushed-nickel"
      ]
    },
    {
      "label": "Shutter - Pure Wood",
      "value": "pure-wood",
      "minWidth": 208,
      "minHeight": 250,
      "maxWidth": 2400,
      "maxHeight": 3000,
      "colors": [
        "colour-001",
        "colour-003",
        "colour-006",
        "colour-012",
        "colour-019",
        "colour-032",
        "colour-049",
        "colour-051",
        "stain-108",
        "stain-109",
        "stain-110",
        "stain-114",
        "stain-204",
        "stain-211",
        "stain-212",
        "stain-215",
        "stain-219",
        "stain-220",
        "stain-221",
        "stain-227",
        "stain-230",
        "stain-237",
        "stain-862"
      ]
    },
    {
      "label": "Honeycomb - Corded",
      "value": "corded",
      "minWidth": 220,
      "minHeight": 250,
      "maxWidth": 2500,
      "maxHeight": 3600,
      "maxArea": 5500,
      "pleat_size": [
        "25mm",
        "45mm"
      ],
      "control_side":[
        "left",
        "right"
      ],
      "stack_side": []
    },
    {
      "label": "Honeycomb - Cordloop + Smart Release",
      "value": "cordloop-smart-release",
      "minWidth": 300,
      "minHeight": 250,
      "maxWidth": 3000,
      "maxHeight": 3600,
      "maxArea": 7500,
      "pleat_size": [
        "25mm",
        "45mm"
      ],
      "control_side": [
        "left",
        "right"
      ],
      "stack_side": []
    },
    {
      "label": "Honeycomb - Cordless",
      "value": "cordless",
      "minWidth": 280,
      "minHeight": 250,
      "maxWidth": 2500,
      "maxHeight": 2200,
      "maxArea": 5500,
      "pleat_size": [
        "25mm",
        "45mm",
        "62mm"
      ],
      "control_side": [],
      "stack_side": []
    },
    {
      "label": "Honeycomb - Smart Fit",
      "value": "smart-fit",
      "minWidth": 220,
      "minHeight": 150,
      "maxWidth": 1800,
      "maxHeight": 2200,
      "maxArea": 2600,
      "pleat_size": [
        "25mm"
      ],
      "control_side": [],
      "stack_side": []
    },
    {
      "label": "Honeycomb - Decoflex",
      "value": "decoflex",
      "minWidth": 267,
      "minHeight": 203,
      "maxWidth": 1880,
      "maxHeight": 2235,
      "maxArea": 2750,
      "pleat_size": [
        "25mm"
      ],
      "control_side": [],
      "stack_side": []
    },
    {
      "label": "Honeycomb - Vertical",
      "value": "vertical",
      "minWidth": 750,
      "minHeight": 600,
      "maxWidth": 2900,
      "maxHeight": 2900,
      "maxArea": 11100,
      "pleat_size": [
        "62mm"
      ],
      "control_side": [],
      "stack_side": [
        "left",
        "right",
        "split"
      ]
    },
    {
      "label": "Venetian - Hardwood",
      "value": "hardwood",
      "minWidth": 208,
      "minHeight": 250,
      "maxWidth": 2400,
      "maxHeight": 3000
    },
    {
      "label": "Venetian - Faux Wood",
      "value": "faux-wood",
      "minWidth": 208,
      "minHeight": 250,
      "maxWidth": 2400,
      "maxHeight": 3000
    }
  ]
}
